<div
  [attr.data-testId]="'display-' + context.column.header.name + '-' + context.row.index"
  class="mandatoryDateContainer"
>
  <span class="mandatory">*</span>
  <mat-icon svgIcon="calendar" class="ml-1 align-self-end icon--primary calendar"></mat-icon>
</div>
